<style scoped>
.validValueCss {
  display: inline-block;
  font-family: SimSun;
  font-size: 12px;
  color: #ed3f14;
  position: relative;
  top:0px;
  left: 5px;
}
</style>
<template>
  <div>
      <!--返回列表按钮-->
      <div style="margin:0 0 10px 10px;">
        <Icon type="chevron-left"></Icon>
        <a @click='backPage'>{{ $t('common.backToList') }}</a>
      </div>
      <div style="background-color: #fff;margin:0 10px 0 10px;padding:10px 0 0 10px;">
        <Form ref="pageParams" :model="pageParams" :label-width="180" label-position="right" :rules="ruleValidate">
            <span style="color:#ed3f14;font-size:10px;">({{$t('logisticsProvider.remark')}})</span>
            <h2>{{$t('logisticsProvider.baseInformation')}}</h2>
            <div style="padding-left:20px;padding-top:10px;">
              <Row>
                <!-- 渠道名称 -->
                <Col span="10">
                  <Form-item :label="$t('logisticsProvider.channelName') + '：'" prop="shippingMethodName">
                    <Input v-model.trim="pageParams.shippingMethodName"></Input>
                  </Form-item>
                </Col>
                <!-- 渠道代码 -->
                <Col span="10" push="2">
                  <Form-item :label="$t('logisticsProvider.channelNum') + '：'" prop="shippingMethodCode">
                    <Input v-model.trim="pageParams.shippingMethodCode"></Input>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <!-- 物流公司ID -->
                <Col span="10">
                  <Form-item :label="$t('logisticsProvider.shippingCompanyId') + '：'" prop="shippingCompanyId">
                    <Input v-model.trim="pageParams.shippingCompanyId"></Input>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <!-- 是否有跟踪号 -->
                  <Form-item :label="$t('common.haveTrackNum') + '：'" prop="hasTrackingNumber">
                    <RadioGroup v-model="pageParams.hasTrackingNumber">
                      <Radio :label="1">{{ $t('common.yes') }}</Radio>
                      <Radio :label="0">{{ $t('common.not') }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col>
                <Col span="10">
                  <!-- 是否需要交运 -->
                  <Form-item :label="$t('common.confirmRequired') + '：'" prop="confirmRequired">
                    <RadioGroup v-model="pageParams.confirmRequired">
                      <Radio v-for="item in yesOrNo" :label="item.value" :key='item.value'>{{ item.text }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <!-- 渠道类型 -->
                  <Form-item :label="$t('common.channelTypes') + '：'" prop="logisType">
                    <RadioGroup v-model="pageParams.logisType">
                      <Radio :label='1'>{{ $t('common.logisType1') }}</Radio>
                      <Radio :label='2'>{{ $t('common.logisType2') }}</Radio>
                      <Radio :label='3'>{{ $t('common.logisType3') }}</Radio>
                      <Radio :label='4'>{{ $t('common.logisType4') }}</Radio>
                      <Radio :label='5'>{{ $t('common.logisType5') }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col>
                <Col span="10">
                  <!-- 接收类型 -->
                  <Form-item :label="$t('common.acceptType') + '：'" prop="extendValue2">
                    <CheckboxGroup v-model="pageParams.extendValue2" @on-change="selectReceiveChange">
                      <Checkbox :label="d.value" v-for='(d, index) in productsType' :key='index'>{{d.goodsTypeName}}</Checkbox>
                    </CheckboxGroup>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <!-- 尺寸限制 -->
                <Col span="12" >
                  <Form-item :label="$t('common.sizeLimit')+'： '">
                    <Row>
                      <Col span="1"><span>{{$t('common.length')}}</span></Col>
                      <Col span="4">
                        <Form-item prop="maxSizeLength">
                          <Input v-model.trim="pageParams.maxSizeLength"></Input>
                        </Form-item>
                      </Col>
                      <Col span="2">cm</Col>
                      <Col span="1"><span>{{$t('common.width')}}</span></Col>
                      <Col span="4">
                        <Form-item prop="maxSizeWidth">
                          <Input v-model.trim="pageParams.maxSizeWidth"></Input>
                        </Form-item>
                      </Col>
                      <Col span="2">cm</Col>
                      <Col span="1"><span>{{$t('common.height')}}</span></Col>
                      <Col span="4">
                        <Form-item prop="maxSizeHeight">
                          <Input v-model.trim="pageParams.maxSizeHeight"></Input>
                        </Form-item>
                      </Col>
                      <Col span="1">cm</Col>
                    </Row>
                  </Form-item>
                </Col>
                <!-- 适用重量 -->
                <Col span="10">
                  <Form-item :label="$t('common.useWeight')+'： '">
                    <Row>
                      <Col span="8">
                        <Form-item prop="weightRangeStart">
                          <Input v-model.trim="pageParams.weightRangeStart"></Input>
                        </Form-item>
                      </Col>
                      <Col span="1">g</Col>
                      <Col span="4" style="text-align:center;"><span>——</span></Col>
                      <Col span="8">
                        <Form-item prop="weightRangeEnd">
                          <Input v-model.trim="pageParams.weightRangeEnd"></Input>
                        </Form-item>
                      </Col>
                      <Col span="1">g</Col>
                    </Row>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                <Col span="12">
                  <!-- 可接受包裹类型 -->
                  <Form-item :label="$t('common.packageType') + '：'">
                    <CheckboxGroup v-model="extendValue1" @on-change="selectPackageChange">
                      <Checkbox label="package">{{$t('common.package')}}</Checkbox>
                      <Checkbox label="File">{{$t('common.file')}}</Checkbox>
                    </CheckboxGroup>
                  </Form-item>
                </Col>
                <!-- 参考时效 -->
                <Col span="12">
                  <Form-item :label="$t('common.referTime')+'：'">
                    <Row>
                      <Col span="8">
                        <Form-item prop="deliveryEfficiencyMin">
                          <Input v-model.trim="pageParams.deliveryEfficiencyMin"></Input>
                        </Form-item>
                      </Col>
                      <Col span="3" style="text-align:center;"><span>——</span></Col>
                      <Col span="8">
                        <Form-item prop="deliveryEfficiencyMax">
                          <Input v-model.trim="pageParams.deliveryEfficiencyMax"></Input>
                        </Form-item>
                      </Col>
                    </Row>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                 <!-- 是否支持接口传送面单 -->
                <!-- <Col span="12">
                  <Form-item :label="$t('common.isPrintTemplate') + '：'">
                    <RadioGroup v-model="pageParams.isPrintTemplate">
                      <Radio :label="1">{{ $t('common.yes') }}</Radio>
                      <Radio :label="0">{{ $t('common.not') }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col> -->
                <!-- 保险服务 -->
                <Col span="12">
                  <Form-item :label="$t('common.safeServe') + '：'">
                    <RadioGroup v-model="pageParams.isInsurance">
                      <Radio :label="1">{{ $t('common.yes') }}</Radio>
                      <Radio :label="0">{{ $t('common.not') }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col>
                <Col span="10">
                  <!-- 追踪信息查询网址 -->
                  <Form-item :label="$t('common.trackUrl') + '：'" prop="trackUrl">
                    <Input v-model.trim="pageParams.trackUrl"></Input>
                  </Form-item>
                </Col>
              </Row>
              <Row>
                 <!-- 是否支持接口传送面单 -->
                <Col span="12">
                  <Form-item :label="$t('common.isPrintTemplate') + '：'">
                    <RadioGroup v-model="pageParams.isPrintTemplate">
                      <Radio :label="1">{{ $t('common.yes') }}</Radio>
                      <Radio :label="0">{{ $t('common.not') }}</Radio>
                    </RadioGroup>
                  </Form-item>
                </Col>
                <Col span="10">

                </Col>
              </Row>
          </div>
          <div class="cutline"></div>
          <!-- 动态参数 -->
          <div class="canalInfo" v-if="dyParams.length">
            <h2>{{$t('common.dyParams')}}</h2>
            <div class="explain" style="padding-left: 20px;">
              <div class="paramsCont" v-for="(item, index) in dyParams" :key="index">
                <Form-item v-if="item.parameterType !== '05' && item.parameterType !== '06'" :label="item.parameterName + '：'">
                  <!-- 01:radio -->
                  <RadioGroup v-model="dyParams[index].paramValue1" style="display:inline-block;marginLeft:3px;" v-if="item.parameterType === '01'">
                    <Radio v-for="(n, i) in item.optionList" :key="i" :label="n.parameterValue">{{n.parameterValDesc}}</Radio>
                  </RadioGroup>
                  <!-- 02:checkbox -->
                  <CheckboxGroup v-model="dyParams[index].paramValue2" style="display:inline-block;marginLeft:3px;" v-if="item.parameterType === '02'">
                    <Checkbox v-for="(n, i) in item.optionList" :key="i" :label="n.parameterValue">{{n.parameterValDesc}}</Checkbox>
                  </CheckboxGroup>
                  <!-- 03:input -->
                  <Input v-if="item.parameterType === '03'" :disabled="item.parameterKey == 'currency' && dyParams[index].tempValue && dyParams[index].tempValue != ''" v-model.trim="dyParams[index].paramValue3" style="width:300px;"></Input>
                  <!-- 04:select -->
                  <!-- <select v-if="item.parameterType === '04'" v-model="dyParams[index].paramValue4" style="display:inline-block;marginLeft:3px;border: 1px solid #cccccc;height:28px;width:120px;">
                      <option :value="n.parameterValue" v-for="(n, i) in item.optionList" :key="i">{{n.parameterValueDesc}}</option>
                  </select> -->
                  <Select v-if="item.parameterType === '04'" v-model="dyParams[index].paramValue4" style="width:180px;">
                    <Option v-for="(n, i) in item.optionList" :value="n.parameterValue" :key="i">{{n.parameterValueDesc}}</Option>
                  </Select>
                  <!-- 05:hidden -->
                  <!-- 06-readonly -->
                </Form-item>
              </div>
            </div>
          </div>
          <div class="cutline" v-if="dyParams.length"></div>
          <!-- 暂不显示<div class="canalInfo">
            <h2 style="display:inline-block;">{{$t('common.collectCity')}}</h2>
            <Button style="display:inline-block;float:right;marginRight:10px;" @click="editCityData" type="primary" size="small" icon="edit">{{$t('common.edit')}}</Button>
            <div class="colCity">
              <div class="cityStyle" v-for="(item, index) in cloCityList" :key="index">{{item.cityName}}</div>
            </div>
          </div>
          <div class="cutline"></div> -->
          <!-- 计费模型 -->
          <!-- 暂不显示<div class="canalInfo">
            <h2 style="display:inline-block;">{{$t('logisticsProvider.chargingModel')}}</h2>
            <div class='fr' style="margin-right:10px;">
              <Button type="primary" size="small" icon="ios-upload-outline" @click="showImportExcelModal">{{ $t('common.batchImport') }}</Button>
              <Button type="primary" size="small" icon="plus" @click="addCharge">{{ $t('common.newPartition') }}</Button>
            </div>
            <div class="chargExplain">
              <dTable highlight-row disabled-hover border stripe :columns="chargColumns" :data="chargData" size="small"></dTable>
            </div>
          </div>
          <div class="cutline"></div> -->
          <!-- 发货说明 -->
          <div class="canalInfo">
            <h2>{{$t('common.sendExplain')}}</h2>
            <Row>
              <Col span="12">
                <Form-item>
                  <Input v-model.trim="pageParams.deliverDesc" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :placeholder="$t('logisticsProvider.enterShipDes')"></Input>
                </Form-item>
              </Col>
            </Row>
          </div>
        </Form>
        <div class='fr' style="margin:20px 0;">
          <Button @click="cancel" style="margin-right:10px;" icon="close-round">{{$t('common.cancel')}}</Button>
          <Button type="primary" @click="saveBtn" :loading="loading2" icon="checkmark-round">{{$t('common.save')}}</Button>
        </div>
      </div>
      <!-- 揽收城市 -->
      <div v-if="collectCityModal">
        <Modal :transfer="false" v-model="collectCityModal" width="900" :mask-closable="false" @on-cancel="closeCityModal">
          <p slot="header">
            <span>{{$t('common.collectCity')}}</span>
          </p>
          <div>
            <Row>
              <Col span="17">
                <Button-group size="small">
                  <Button type="primary" style="padding:2px 36px;" @click="chickProvince">{{$t('logisticsProvider.province')}}</Button>
                  <Button type="info" style="padding:2px 36px;" v-if="!showFlag">{{$t('logisticsProvider.city')}}</Button>
                </Button-group>
              </Col>
            </Row>
            <div style="border:1px solid lightgray;width:100%;height:254px;position:relative;">
              <Form>
                <div style="border-bottom:1px solid lightgray;width:100%; height:150px;position:absolute;padding:5px;overflow:auto;">
                  <div v-if="showFlag">
                    <Form-item>
                      <Button type="default" size="small" v-for="(item, index) in provinceList" :key="index" style="margin-right:8px;" @click="selectProvince(item.stateId)">{{item.cnName}}</Button>
                    </Form-item>
                  </div>
                  <div v-if="!showFlag">
                    <div style="border-bottom: 1px solid #e9e9e9;padding-bottom:6px;margin-bottom:6px;">
                      <Checkbox :indeterminate="indeterminate" :value="checkAll" @click.prevent.native="handleCheckCityNames">{{$t('logisticsProvider.selectAll')}}</Checkbox>
                    </div>
                    <Form-item>
                      <CheckboxGroup v-model="cityParams" @on-change="checkCitysGroupChange">
                        <Checkbox :label="d.cityId" v-for='(d, index) in cityList' :key='index' v-if="refreshStatus">{{d.cnName}}</Checkbox>
                      </CheckboxGroup>
                    </Form-item>
                  </div>
                </div>
                <div style="width:100%; height:100px;position:absolute;bottom:0px;padding:5px;overflow:auto;">
                  <span>{{$t('logisticsProvider.selectedCity')}}：{{hadSelectedStateName(cityParams)}}</span>
                  <a style="float:right;margin:8% 1% 0 0;" @click="clearSelected">{{$t('logisticsProvider.clear')}}</a>
                </div>
              </Form>
            </div>
          </div>
          <div slot="footer">
            <Button type="primary" @click="confirmAddCity">{{$t('logisticsProvider.confirmAdd')}}</Button>
          </div>
        </Modal>
      </div>
      <!-- 计费模型 -->
        <Modal v-model="pricingModal" :mask-closable="false" width="1000" @on-cancel="pricingCancel">
          <p slot="header">
            <span>{{$t('logisticsProvider.chargingModel')}}</span>
          </p>
          <pricingModel
          ref="clearTableData"
          :isAddOrEdit="isAddOrEdit"
          :shipId="shipId"
          :priceModelId="priceModelId"
          :priceModelZoneId="priceModelZoneId"
          :curSingleDtl="curSingleDtl"
          :clickIndex="clickIndex"
          :getArriveCountryList="getArriveCountryList"
          @addPricesData="getAddPriceData"
          @sendData="getData"
          @closeModal="closeFlag">
          </pricingModel>
          <div slot="footer">
            <Button @click="pricingCancel">{{$t('common.cancel')}}</Button>
            <Button type="primary" @click="saveData">{{$t('common.save')}}</Button>
          </div>
        </Modal>
      <!-- 删除确认框 -->
      <Modal v-model="delModal" transfer :title="$t('logisticsProvider.prompt')" :styles="{top: '260px', width:'400px'}" @on-ok="delOk" @on-cancel="delCancel" :mask-closable="false">
        <h3 style="margin:10px 35%">{{$t('common.deleteConfirm')}}</h3>
      </Modal>
      <!-- 模板下载 -->
      <Modal v-if="excelModalStatus" v-model="excelModal" transfer :mask-closable="false" @on-cancel="cancelUploadExcel">
        <p slot="header">
          <span>{{$t('logisticsProvider.loadExcelTitle')}}</span>
        </p>
        <Form ref="modelParams" :model="modelParams" label-position="left">
          <FormItem :label="$t('common.priceType') + '：'" prop="priceType">
            <RadioGroup v-model="modelParams.priceType">
              <Radio :label="1">{{ $t('common.priceType0') }}</Radio>
              <Radio :label="2">{{ $t('common.priceType1') }}</Radio>
              <Radio :label="3">{{ $t('common.subCostWay1') }}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem :label="$t('common.weightType') + '：'" prop="weightType">
            <RadioGroup v-model="modelParams.weightType">
              <Radio :label="1">{{ $t('common.weightType0') }}</Radio>
              <Radio :label="2">{{ $t('common.weightType1') }}</Radio>
              <Radio :label="3">{{ $t('common.weightType2') }}</Radio>
            </RadioGroup>
            <div style="display: inline-block;" v-if="modelParams.weightType === 2 || modelParams.weightType === 3">
              ( {{ $t('common.volumeWeight') + ':' }} <InputNumber :min="0" style="width: 100px;" v-model="modelParams.volumeWeight"></InputNumber> )
            </div>
          </FormItem>
          <FormItem :label="$t('logisticsProvider.downloadExcel') + '：'" :label-width="80">
            <a @click="downLoadExcelFiles" class="blurColor">{{$t('logisticsProvider.downloadExcel')}}</a>
          </FormItem>
          <FormItem :label="$t('logisticsProvider.selectExcel') + '：'">
            <Upload
              v-if="uploadPath && uploadHeader.hasOwnProperty('Authorization')"
              :action="uploadPath"
              :show-upload-list="false"
              :data="modelParams"
              ref="uploadFiles"
              name="file"
              :format="['xlsx', 'xls']"
              :before-upload="handleBeforeUpload"
              :headers="uploadHeader"
              :on-success="uploadSuccess"
              :on-error="uploadError"
              :on-format-error="handleFormatError"
              >
              <Button type="primary" class="normalRMargin">{{$t('common.selectFile')}}</Button>
            </Upload>
            <div v-if="file !== null" class="blurColor">{{file.name}}</div>
          </FormItem>
          <FormItem :label="$t('common.findSameCountry') + '：'">
            <RadioGroup v-model="modelParams.covered">
              <Radio :label="1">{{$t('common.cover')}}</Radio>
              <Radio :label="0">{{$t('common.ignore')}}</Radio>
            </RadioGroup>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="cancelUploadExcel">{{$t('common.cancel')}}</Button>
          <Button type="primary" :loading="uploadLoading" @click="confirmUploadExcel">{{$t('common.startUpload')}}</Button>
        </div>
      </Modal>
      <Modal v-model="errorTipModal" :mask-closable="false" :styles="{top: '260px',width:'400px'}" @on-cancel="cancelDownLoad">
        <p slot="header">
          <span>{{$t('common.errorMessage')}}</span>
        </p>
        <div>{{errorTipInfo}}</div>
        <div slot="footer">
          <Button @click="cancelDownLoad">{{$t('common.close')}}</Button>
          <Button @click="downloadError" type="primary" v-if="showErrorCode === 20058">{{$t('common.downloadErrorLog')}}</Button>
        </div>
      </Modal>
  </div>
</template>
<script>
import api from '@/api/api';
import Mixin from '@/components/mixin/common_mixin';
import tableMixin from '@/components/mixin/table_mixin';
import pricingModel from './pricingModel';
export default {
  props: ['shippingId', 'addFlag'],
  mixins: [ Mixin, tableMixin ],
  components: {
    pricingModel
  },
  data () {
    let self = this;
    return {
      selectedCitysArr: [], // 编辑已经选中的城市
      refreshStatus: true,
      allCityNames: [], // 所有城市列表
      showFlag: true,
      indeterminate: true,
      checkAll: false,
      getArriveCountryList: [], // 通达国家列表数据
      alreadySelectedCountry: [], // 已经选中的国家
      errorTipInfo: '', // 错误的提示信息
      errorDownloadLink: '', // 错误日志下载链接
      showErrorCode: null, // 20058错误code值
      clickIndex: null, // 当前行的下标
      isAddOrEdit: '',
      curSingleDtl: {},
      errorTipModal: false,
      uploadLoading: false, // 开始上传加载
      excelModalStatus: false,
      excelModal: false,
      uploadPath: api.upload_excel2ver,
      modelParams: {
        priceType: 1, // 计费方式
        weightType: 1, // 计重方式
        volumeWeight: 0, // 材积重
        shippingMethodId: '', // 渠道ID
        priceModelId: '', // 计费模型ID
        merchantId: '', // 商户ID
        covered: 1 // 覆盖或者忽略
      },
      file: null,
      uploadHeader: {
        'Authorization': sessionStorage.getItem('token')
      },
      delModal: false, // 删除模态框
      loading2: false,
      shipId: null, // 渠道ID
      pageParams: {
        deliveryEfficiencyMax: '', // 参考时效最大值
        deliveryEfficiencyMin: '', // 参考时效最小值
        isInsurance: '', // 保险服务
        maxSizeHeight: '', // 尺寸限制高
        maxSizeLength: '', // 尺寸限制长
        maxSizeWidth: '', // 尺寸限制宽
        weightRangeStart: '', // 适用重量起始值
        weightRangeEnd: '', // 适用重量截止值
        logisType: '', // 渠道类型
        shippingMethodExtendInfoId: '', // 渠道扩展信息ID
        shippingMethodName: '', // 渠道名称
        shippingMethodCode: '', // 渠道代码
        shippingCompanyId: '', // 物流公司ID
        extendTypeList: [], // 渠道扩展类型（包裹类型、接收类型）
        hasTrackingNumber: '', // 是否有跟踪号
        isPrintTemplate: 1, // 是否支持接口传送面单
        confirmRequired: 0, // 是否需要交运
        trackUrl: '', // 追踪信息查询网址
        defParamList: [], // 保存的动态参数
        deliverDesc: '', // 发货说明
        pickupCityList: [], // 揽收城市
        priceModel: {}, // 计费模型
        extendValue2: [] // 接收类型
      },
      yesOrNo: [
        {
          value: 1,
          text: '是'
        }, {
          value: 0,
          text: '否'
        }
      ],
      // 校验
      ruleValidate: {
        shippingMethodName: [
          { required: true, message: self.t('validValue.noshipMethodName'), trigger: 'blur' }
        ],
        shippingMethodCode: [
          { required: true, message: self.t('validValue.noshipMethodCode'), trigger: 'blur' },
          { validator: self.validateMethodCode(), trigger: 'blur' }
        ],
        hasTrackingNumber: [
          { required: true, message: self.t('validValue.noHasTrackingNumber'), trigger: 'blur' }
        ],
        logisType: [
          // { required: true, message: self.t('validValue.noLogisType') }
        ],
        trackUrl: [
          { validator: self.validateUrl(), trigger: 'blur' }
        ],
        deliveryEfficiencyMin: [
          // { required: true, message: self.t('validValue.noEfficiencyMin'), trigger: 'blur' },
          { validator: self.validateVal(), trigger: 'blur' }
        ],
        deliveryEfficiencyMax: [
          // { required: true, message: self.t('validValue.noEfficiencyMax'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        maxSizeLength: [
          // { required: true, message: self.t('validValue.noLength'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        maxSizeWidth: [
          // { required: true, message: self.t('validValue.noWidth'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        maxSizeHeight: [
          // { required: true, message: self.t('validValue.noHeight'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        weightRangeStart: [
          // { required: true, message: self.t('validValue.noWeightStart'), trigger: 'blur' },
          { validator: self.validateVal(), trigger: 'blur' }
        ],
        weightRangeEnd: [
          // { required: true, message: self.t('validValue.noWeightEnd'), trigger: 'blur' },
          { validator: self.validateZero(), trigger: 'blur' }
        ],
        extendValue2: [
          // { required: true, type: 'array', message: self.t('validValue.noReceiveType'), trigger: 'change' }
        ]
      },
      productsType: [
        {
          value: '01',
          goodsTypeName: self.t('common.cargo')
        },
        {
          value: '02',
          goodsTypeName: self.t('common.battery')
        },
        {
          value: '03',
          goodsTypeName: self.t('common.supBattery')
        },
        {
          value: '04',
          goodsTypeName: self.t('common.liquid')
        },
        {
          value: '05',
          goodsTypeName: self.t('common.medicine')
        },
        {
          value: '06',
          goodsTypeName: self.t('common.powder')
        },
        {
          value: '07',
          goodsTypeName: self.t('common.dangerous')
        }
      ],
      extendValue1: [], // 可接受包裹类型
      dyParams: [], // 动态参数
      collectCityModal: false, // 揽收城市模态框
      provinceParams: [], // 省份
      provinceList: [], // 省份列表
      cityParams: [], // 城市
      cityList: [], // 城市列表
      cityModalList: [], // 城市及id
      cloCityList: [], // 展示的揽收城市
      delIndex: null, // 删除行的下标
      priceModelId: null,
      priceModelZoneId: null,
      chargColumns: [
        {
          title: self.t('common.subArea'),
          width: 80,
          align: 'center',
          render: (h, params) => {
            return h('span', params.index + 1 + self.t('logisticsProvider.area'));
          }
        },
        {
          title: self.t('common.reachState'),
          key: 'reachState',
          minWidth: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', self.setStateData(params.index, 'text'));
          }
        },
        {
          title: self.t('common.priceType'),
          key: 'priceType',
          align: 'center',
          render: (h, params) => {
            if (params.row.priceType === 1) {
              return h('span', self.t('common.priceType0'));
            } else if (params.row.priceType === 2) {
              return h('span', self.t('common.priceType1'));
            } else if (params.row.priceType === 3) {
              return h('span', self.t('common.subCostWay1'));
            }
          }
        },
        {
          title: self.t('common.weightType'),
          key: 'weightType',
          align: 'center',
          render: (h, params) => {
            if (params.row.weightType === 1) {
              return h('span', self.t('common.weightType0'));
            } else if (params.row.weightType === 2) {
              return h('span', self.t('common.weightType1'));
            } else if (params.row.weightType === 3) {
              return h('span', self.t('common.weightType2'));
            }
          }
        },
        {
          title: self.t('logisticsProvider.priceFormula'),
          key: 'formula',
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', params.row.formula);
          }
        },
        {
          title: self.t('common.operation'),
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  size: 'small',
                  type: 'primary'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    self.pricingModal = true;
                    self.isAddOrEdit = 'edit';
                    self.priceModelId = params.row.priceModelId; // 计费模型ID
                    self.priceModelZoneId = params.row.priceModelZoneId; // 分区ID
                    self.curSingleDtl = params.row; // 当前行的计费模型数据
                    self.clickIndex = params.index;
                  }
                }
              }, self.t('common.edit')),
              h('Button', {
                props: {
                  size: 'small',
                  type: 'error'
                },
                on: {
                  click: () => {
                    self.delModal = true;
                    self.delIndex = params.index;
                    self.priceModelId = params.row.priceModelId; // 计费模型ID
                    self.priceModelZoneId = params.row.priceModelZoneId; // 分区ID
                  }
                }
              }, self.t('common.del'))
            ]);
          }
        }
      ],
      chargData: [], // 计费模型表格数据
      pricingModal: false, // 计费模型模态框
      selectedDataList: [], // 已选择的动态参数列表
      clickChargeFlag: '' // 点击编辑计费模型标识
    };
  },
  methods: {
    // 返回列表
    backPage () {
      this.$parent.workShow = 'list';
    },
    // 缺认删除
    delOk () {
      let v = this;
      if (v.priceModelId !== '' && v.priceModelId !== null && v.priceModelZoneId !== '' && v.priceModelZoneId !== null) {
        v.axios.post(api.del_zone2ver + '?priceModelId=' + v.priceModelId + '&priceModelZoneId=' + v.priceModelZoneId)
          .then(res => {
            if (res.data.code === 0) {
              v.$Message.success(v.t('common.delSuccess'));
              v.refreshTable();
            } else {
              v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
            }
          });
      } else {
        v.chargData.splice(v.delIndex, 1);
        if (!v.chargData.length) {
          v.getArriveCountryList = [];
        }
      }
    },
    // 取消删除
    delCancel () {
      this.delModal = false;
    },
    // 保存渠道信息校验
    saveValidFn () {
      let v = this;
      let valid = true;
      // var reg = /^\d+$/;
      // 渠道名称
      if (v.pageParams.shippingMethodName === '') {
        v.$Message.info({
          content: v.t('validValue.noshipMethodName'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 渠道代码
      var re = /[\u4e00-\u9fa5]/;
      let value = v.pageParams.shippingMethodCode;
      if (re.test(value) && value !== '') {
        // v.$Message.info({
        //   content: v.t('validValue.chMethodCode'),
        //   duration: 3
        // });
        // valid = false;
        // return;
      } else if (value === '') {
        v.$Message.info({
          content: v.t('validValue.noshipMethodCode'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 是否有跟踪号
      let receiveTrackList = v.pageParams.hasTrackingNumber;
      if (receiveTrackList.length === 0) {
        v.$Message.info({
          content: v.t('validValue.noHasTrackingNumber'),
          duration: 3
        });
        valid = false;
        return;
      }
      // 参考时效最小值
      // let minVal = v.pageParams.deliveryEfficiencyMin;
      // if (minVal !== '' && !reg.test(minVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.isInteger'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // } else if (Number(minVal) < 0 && minVal !== '') {
      //   v.$Message.info({
      //     content: v.t('validValue.minTimeNoLessZero'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // 参考时效最大值
      // let maxVal = v.pageParams.deliveryEfficiencyMax;
      // if (maxVal !== '' && !reg.test(maxVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.isInteger'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // } else if (maxVal !== '' && Number(maxVal) <= 0) {
      //   v.$Message.info({
      //     content: v.t('validValue.maxTimeNoLessOrEqualZero'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // if (minVal !== '' && maxVal !== '' && Number(minVal) >= Number(maxVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.noStartTimeMoreEndTime'),
      //     duration: 4
      //   });
      //   valid = false;
      //   return;
      // }
      // 尺寸限制长
      // let lengthVal = v.pageParams.maxSizeLength;
      // if (lengthVal !== '' && !reg.test(lengthVal) ) {
      //   v.$Message.info({
      //     content: v.t('validValue.isInteger'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // } else if (Number(lengthVal) <= 0 && lengthVal !== '') {
      //   v.$Message.info({
      //     content: v.t('validValue.lengthNoLessOrEqualZero'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // 尺寸限制宽
      // let widthVal = v.pageParams.maxSizeWidth;
      // if (widthVal !== '' && !reg.test(widthVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.isInteger'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // } else if (Number(widthVal) <= 0 && widthVal !== '') {
      //   v.$Message.info({
      //     content: v.t('validValue.widthNoLessOrEqualZero'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // 尺寸限制高
      // let heightVal = v.pageParams.maxSizeHeight;
      // if (heightVal !== '' && !reg.test(heightVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.isInteger'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // } else if (Number(heightVal) <= 0 && heightVal !== '') {
      //   v.$Message.info({
      //     content: v.t('validValue.heightNoLessOrEqualZero'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // 适用重量起始值
      // let weightStartVal = v.pageParams.weightRangeStart;
      // if (weightStartVal !== '' && !reg.test(weightStartVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.isInteger'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // } else if (Number(weightStartVal) < 0 && weightStartVal !== '') {
      //   v.$Message.info({
      //     content: v.t('validValue.startWeightNoLessZero'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // 适用重量截止值
      // let weightEndVal = v.pageParams.weightRangeEnd;
      // if (weightEndVal !== '' && !reg.test(weightEndVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.isInteger'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // } else if (Number(weightEndVal) <= 0 && weightEndVal !== '') {
      //   v.$Message.info({
      //     content: v.t('validValue.endWeightNoLessOrEqualZero'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // if (weightStartVal !== '' && weightEndVal !== '' && Number(weightStartVal) >= Number(weightEndVal)) {
      //   v.$Message.info({
      //     content: v.t('validValue.noStartMoreEnd'),
      //     duration: 4
      //   });
      //   valid = false;
      //   return;
      // }
      // 接收类型
      // let receiveList = v.pageParams.extendValue2;
      // if (receiveList.length === 0) {
      //   v.$Message.info({
      //     content: v.t('validValue.noReceiveType'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // 渠道类型
      // if (v.pageParams.logisType === '') {
      //   v.$Message.info({
      //     content: v.t('validValue.noLogisType'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      // 追踪信息查询网址
      // var regUrl = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\/])+$/;
      // let urlVal = v.pageParams.trackUrl;
      // if (!regUrl.test(urlVal) && urlVal !== '' && urlVal !== null) {
      //   v.$Message.info({
      //     content: v.t('validValue.trackUrlError'),
      //     duration: 3
      //   });
      //   valid = false;
      //   return;
      // }
      return valid;
    },
    // 渠道代码校验
    validateMethodCode () {
      var reg = /[\u4e00-\u9fa5]/;
      var validateMethodCode = function (rule, value, callback) {
        if (reg.test(value) && value !== '') {
          // callback(new Error(v.t('validValue.chMethodCode')));
        } else {
          callback();
        }
      };
      return validateMethodCode;
    },
    // 校验数字
    validateVal () {
      let v = this;
      var reg = /^\d+$/;
      var validateVal = function (rule, value, callback) {
        if (!reg.test(value) && value !== '') {
          callback(new Error(v.t('validValue.isInteger')));
        } else if (Number(value) < 0 && value !== '') {
          callback(new Error(v.t('validValue.noLessZero')));
        } else {
          callback();
        }
      };
      return validateVal;
    },
    // 校验是否小于等于0
    validateZero () {
      let v = this;
      var reg = /^\d+$/;
      var validateZero = function (rule, value, callback) {
        if (!reg.test(value) && value !== '') {
          callback(new Error(v.t('validValue.isInteger')));
        } else if (Number(value) <= 0 && value !== '') {
          callback(new Error(v.t('validValue.noLessOrEqualZero')));
        } else {
          callback();
        }
      };
      return validateZero;
    },
    // 追踪信息查询网址校验
    validateUrl () {
      let v = this;
      var reg = /^([hH][tT]{2}[pP]:\/\/|[hH][tT]{2}[pP][sS]:\/\/)(([A-Za-z0-9-~]+)\.)+([A-Za-z0-9-~\\/])+$/;
      // var isUrl = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/;
      var validateUrl = function (rule, value, callback) {
        if (!reg.test(value) && value !== '' && value !== null) {
          callback(new Error(v.t('validValue.trackUrlError')));
        } else {
          callback();
        }
      };
      return validateUrl;
    },
    // 点击省份
    chickProvince () {
      let v = this;
      if (v.cityList.length) {
        v.showFlag = !v.showFlag;
      }
    },
    // 全选所有城市
    handleCheckCityNames () {
      let v = this;
      let arr = [];
      let box = [];
      if (v.indeterminate) {
        v.checkAll = false;
      } else {
        v.checkAll = !v.checkAll;
      }
      v.indeterminate = false;
      v.cityList.forEach((item, index) => {
        arr.push(item.cityId);
        box.push(item);
      });
      if (v.checkAll) {
        v.cityParams = arr;
        // v.cityModalList = box;
        v.allCityNames = v.filterDeleteArrFn(v.allCityNames.concat(box), 'cityId');
      } else {
        v.cityParams = [];
        v.cityModalList = [];
      }
    },
    // 勾选城市
    checkCitysGroupChange (data) {
      let v = this;
      let pos = [];
      if (data.length === v.cityList.length) {
        v.indeterminate = false;
        v.checkAll = true;
        v.cityParams = data;
        for (let i = 0; i < v.cityList.length; i++) {
          for (let t = 0; t < data.length; t++) {
            if (data[t] === v.cityList[i].cityId) {
              pos.push(v.cityList[i]);
            }
          }
        }
        // v.cityModalList = pos;
        v.allCityNames = v.filterDeleteArrFn(v.allCityNames.concat(pos), 'cityId');
      } else if (data.length > 0) {
        v.indeterminate = true;
        v.checkAll = false;
        v.cityParams = data;
        for (let i = 0; i < v.cityList.length; i++) {
          for (let t = 0; t < data.length; t++) {
            if (data[t] === v.cityList[i].cityId) {
              pos.push(v.cityList[i]);
            }
          }
        }
        // v.cityModalList = pos;
        v.allCityNames = v.filterDeleteArrFn(v.allCityNames.concat(pos), 'cityId');
        // console.log('已选城市：', v.allCityNames);
      } else {
        v.indeterminate = false;
        v.checkAll = false;
      }
    },
    // 把已选中的城市ID转城市名称
    hadSelectedStateName (arr) {
      let v = this;
      if (arr.length === 0) return '';
      let arrName = [];
      let countryArr = [];
      if (v.showFlag === true) {
        v.cityList = v.selectedCitysArr;
      }
      for (let i = 0; i < v.allCityNames.length; i++) {
        let item = v.allCityNames[i];
        for (let t = 0; t < arr.length; t++) {
          let subItem = arr[t];
          if (subItem === item.cityId) {
            arrName.push(item.cnName);
            countryArr.push(item);
          }
          if (i === v.allCityNames.length - 1 && t === arr.length - 1) {
            v.cityModalList = countryArr;
            return arrName.toString();
          }
        }
      }
    },
    // 编辑渠道详情
    getCanalDtlInfo () {
      let v = this;
      let chargeList = [];
      v.axios.post(api.get_shippingInfo2ver + '?shippingMethodId=' + v.shippingId)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            let pos = [];
            let box = [];
            let cityList = [];
            data.extendTypeList.forEach((n, i) => { // 包裹和接收类型
              if (n.extendType === 1) {
                pos.push(n.extendValue);
                v.extendValue1 = pos;
              } else if (n.extendType === 2) {
                box.push(n.extendValue);
                v.pageParams.extendValue2 = box;
              }
            });
            data.pickupCityList.forEach((m, t) => {
              cityList.push({
                cityId: m.cityId,
                cityName: m.cityName
              });
            });
            v.cloCityList = cityList;
            let newCity = [];
            v.cloCityList.forEach(val => {
              newCity.push({
                cnName: val.cityName,
                cityId: val.cityId
              });
            });
            v.selectedCitysArr = newCity;
            let arr = [];
            if (data.priceModel !== null) {
              v.modelParams.priceModelId = data.priceModel.priceModelId; // 计费模型ID
              v.priceModelId = data.priceModel.priceModelId;
              arr = data.priceModel.priceModelZoneList; // 计费模型表格数据
            } else {
              v.modelParams.priceModelId = '';
              v.priceModelId = null;
              arr = [];
            }
            arr.forEach((n, i) => {
              chargeList.push({
                arriveCountryList: n.arriveCountryList,
                priceType: n.priceType,
                weightType: n.weightType,
                volumeWeight: n.volumeWeight,
                formula: n.formula,
                priceModelId: n.priceModelId, // 模型ID
                priceModelZoneId: n.priceModelZoneId, // 分区ID
                subList: n.subList
              });
            });
            v.chargData = chargeList;
            v.pageParams.deliveryEfficiencyMax = data.extendInfo.deliveryEfficiencyMax; // 参考时效最大值
            v.pageParams.deliveryEfficiencyMin = data.extendInfo.deliveryEfficiencyMin; // 参考时效最小值
            v.pageParams.isInsurance = data.extendInfo.isInsurance; // 保险服务
            v.pageParams.maxSizeHeight = data.extendInfo.maxSizeHeight; // 尺寸限制高
            v.pageParams.maxSizeLength = data.extendInfo.maxSizeLength; // 尺寸限制长
            v.pageParams.maxSizeWidth = data.extendInfo.maxSizeWidth; // 尺寸限制宽
            v.pageParams.weightRangeStart = data.extendInfo.weightRangeStart; // 适用重量起始值
            v.pageParams.weightRangeEnd = data.extendInfo.weightRangeEnd; // 适用重量截止值
            v.pageParams.logisType = data.extendInfo.logisType; // 渠道类型
            v.pageParams.shippingMethodExtendInfoId = data.extendInfo.shippingMethodExtendInfoId; // 渠道扩展信息ID
            v.pageParams.shippingMethodName = data.shippingMethodName; // 渠道名称
            v.pageParams.shippingMethodCode = data.shippingMethodCode; // 渠道代码
            v.pageParams.shippingCompanyId = data.shippingCompanyId; // 物流公司ID
            v.pageParams.hasTrackingNumber = data.hasTrackingNumber; // 是否有跟踪号
            v.pageParams.isPrintTemplate = data.isPrintTemplate; // 是否支持接口传送面单
            v.pageParams.confirmRequired = data.confirmRequired; // 是否需要交运
            v.pageParams.trackUrl = data.trackUrl; // 追踪信息查询网址
            v.pageParams.defParamList = data.defParamList; // 保存的动态参数
            v.pageParams.deliverDesc = data.deliverDesc; // 发货说明
            v.pageParams.pickupCityList = data.pickupCityList; // 揽收城市
            v.selectedDataList = data.defParamList; // 选中的动态参数
            v.initSelectParamsFn();
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 获取动态参数
    getParams () {
      let v = this;
      let pos = [];
      v.axios.post(api.get_params2ver)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas;
            if (data) {
              data.forEach((n, i) => {
                pos.push({
                  parameterName: n.parameterName,
                  parameterType: n.parameterType,
                  parameterKey: n.parameterKey,
                  optionList: n.optionList
                });
              });
            }
            v.dyParams = pos;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 保存
    saveData () {
      let v = this;
      v.$refs.clearTableData.savePricingData();
      // v.pricingModal = false;
    },
    // 关闭计费模型弹框
    pricingCancel () {
      let v = this;
      v.pricingModal = false;
      v.isAddOrEdit = '';
      v.$refs.clearTableData.pricingParams.checkCountry = [];
    },
    // 勾选可接收包裹类型
    selectPackageChange (data) {
      let v = this;
      v.extendValue1 = data;
    },
    // 勾选接收类型
    selectReceiveChange (data) {
      let v = this;
      v.pageParams.extendValue2 = data;
    },
    // 编辑揽收城市
    editCityData () {
      let v = this;
      let pos = [];
      v.collectCityModal = true;
      if (v.cloCityList.length) { // 点击编辑时，加入已有的城市和省份
        v.showFlag = true; // 默认显示省份列表
        v.cloCityList.forEach((n, i) => {
          pos.push(n.cityId);
        });
        v.hadSelectedStateName(pos); // 已选城市
        v.cityParams = pos;
      } else {
        v.showFlag = true; // 默认显示省份列表
      }
    },
    // 清空
    clearSelected () {
      let v = this;
      v.cityParams = [];
      v.indeterminate = true;
      v.checkAll = false;
      v.cityModalList = [];
    },
    // 关闭揽收城市模态框
    closeCityModal () {
      this.collectCityModal = false;
    },
    // 确认添加城市
    confirmAddCity () {
      let v = this;
      let pos = [];
      if (!v.cityModalList.length) {
        v.$Message.warning({
          content: v.t('validValue.noCitys'),
          duration: 3
        });
        v.collectCityModal = true;
        return false;
      }
      v.cityModalList.forEach((n, i) => {
        pos.push({
          cityName: n.cnName,
          cityId: n.cityId,
          stateId: n.stateId
        });
      });
      v.cloCityList = pos;
      v.pageParams.pickupCityList = v.cloCityList;
      v.collectCityModal = false;
      v.selectedCitysArr = v.cityModalList;
    },
    // 刷新计费模型表格
    refreshTable () {
      let v = this;
      v.axios.post(api.get_shippingInfo2ver + '?shippingMethodId=' + v.shippingId)
        .then(res => {
          if (res.data.code === 0) {
            let data = res.data.datas.priceModel;
            if (data !== null) {
              v.chargData = data.priceModelZoneList; // 计费模型表格数据
              if (!v.chargData.length) {
                v.getArriveCountryList = [];
              }
            } else {
              v.chargData = [];
            }
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 保存之后关闭计费模型模态框
    closeFlag (data) {
      let v = this;
      v.pricingModal = false;
      v.refreshTable(); // 刷新计费模型表格
    },
    // 新增计费模型保存
    getAddPriceData (data) {
      let v = this;
      v.pricingModal = false; // 新增保存关闭模态框
      v.chargData.push(data);
    },
    // 编辑计费模型保存
    getData (data) {
      let v = this;
      v.pricingModal = false; // 新增保存关闭模态框
      v.chargData.forEach((n, i) => {
        if (i === data.clickIndex) {
          n.arriveCountryList = data.arriveCountryList; // 国家列表
          n.priceType = data.priceType; // 计费方式
          n.weightType = data.weightType; // 计重方式
          n.volumeWeight = data.volumeWeight; // 材积重
          n.subList = data.subList; // 分区表格数据
          n.formula = data.formula; // 计费公式
        }
      });
    },
    // 显示选中的动态参数
    initSelectParamsFn () {
      let v = this;
      for (let i = 0; i < v.dyParams.length; i++) {
        let out = v.dyParams[i]; // 外层
        if (v.dyParams[i].optionList != null) {
          for (let t = 0; t < v.dyParams[i].optionList.length; t++) {
            for (let j = 0; j < v.selectedDataList.length; j++) {
              let a = v.selectedDataList[j]; // 外层
              if (out.parameterType === '01' && out.parameterKey === a.parameterKey) {
                out.paramValue1 = a.parameterValue;
              } else if (out.parameterType === '02') {
                out.paramValue2 = a.parameterValue.split(',');
              } else if (out.parameterType === '04' && out.parameterKey === a.parameterKey) {
                out.paramValue4 = a.parameterValue;
              }
            }
          }
        } else if (out.parameterType === '03') {
          for (let j = 0; j < v.selectedDataList.length; j++) {
            let a = v.selectedDataList[j]; // 外层
            if (out.parameterKey === a.parameterKey) {
              out.paramValue3 = a.parameterValue;
              out.tempValue = a.parameterValue;
            }
          }
        }
      }
    },
    // 下载模板
    downLoadExcelFiles () {
      let v = this;
      const relativePath = window.location.host + '/static/files/';
      let fileName;
      if (v.modelParams.priceType === 1) {
        fileName = 'priceModel-NormalBilling.xlsx';
      } else if (v.modelParams.priceType === 2) {
        fileName = 'priceModel-FirstContinuousRebilling.xlsx';
      } else if (v.modelParams.priceType === 3) {
        fileName = 'priceModel-FixedBilling.xlsx';
      }
      window.location.href = '//' + relativePath + fileName;
    },
    // 导入成功
    uploadSuccess (response, file, fileList) {
      let v = this;
      if (response.code === 0) {
        if (v.shippingId) {
          v.uploadLoading = false;
          v.excelModal = false; // 模态框
          v.file = null;
          v.refreshTable(); // 刷新计费模型表格
          v.$Message.success({
            content: v.t('logisticsProvider.importSuccess'),
            duration: 3
          });
        } else if (!v.shippingId) {
          v.uploadLoading = false;
          v.excelModal = false; // 模态框
          v.file = null;
          // let arr = response.datas.priceModelZoneList;
          // var obj = {};
          // for (var i = 0; i < arr.length; i++) {
          //   let arriveItem = arr[i].arriveCountryList; // 添加的国家
          //   for (var j = 0; j < v.chargData.length; j++) {
          //     let chargeItem = v.chargData[j].arriveCountryList;
          //     for (var k = 0; k < arriveItem.length; k++) {
          //       obj[arriveItem[k].cnName] = 1;
          //       for (var p = 0; p < chargeItem.length; p++) {
          //         if (obj[chargeItem[p].cnName]) {
          //           v.$Message.error({
          //             content: v.t('error.importSameCountry'),
          //             duration: 4
          //           });
          //           return;
          //         }
          //       }
          //     }
          //   }
          // }
          // let data = [];
          // v.chargData = data.concat(v.chargData, arr);
          v.chargData = response.datas.priceModelZoneList;
          v.$Message.success({
            content: v.t('logisticsProvider.importSuccess'),
            duration: 3
          });
        }
      } else if (response.code === 20058) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('common.checkErrorLog');
        v.errorDownloadLink = response.datas.errorPath; // 下载错误日志链接
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        if (arr !== null) {
          let data = [];
          v.chargData = data.concat(v.chargData, arr);
        }
      } else if (response.code === 20013) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20014) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError14');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20015) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError15');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20016) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError16');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20017) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError17');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20018) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError18');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20019) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError19');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20020) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError20');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20021) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError21');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20022) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError22');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20023) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError23');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20024) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError24');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20025) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError25');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20026) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError26');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20027) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError27');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20028) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError28');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20029) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError29');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20030) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError30');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20031) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError31');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20032) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError32');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20033) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError33');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20034) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError34');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20035) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError35');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20036) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError36');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20037) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError37');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20038) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.templateDataError38');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else if (response.code === 20059) {
        v.showErrorCode = response.code;
        v.uploadLoading = false;
        v.file = null;
        v.errorTipInfo = v.t('error.repeatImportCountry');
        v.errorTipModal = true; // 错误提示模态框
        v.excelModal = false; // 导入计费模态框
        let arr = response.datas.priceModelZoneList;
        let data = [];
        v.chargData = data.concat(v.chargData, arr);
      } else {
        v.uploadLoading = false;
      }
    },
    uploadError () {
      let v = this;
      v.$Message.error(v.t('common.operateFailMes'));
    },
    // 上传文件格式校验
    handleFormatError (file) {
      let v = this;
      v.$Notice.warning({
        title: v.t('validValue.fileError'),
        desc: file.name + v.t('validValue.fileError') + ',' + v.t('common.pleaseSelect') + 'xlsx or xls'
      });
      v.uploadLoading = false;
    },
    handleBeforeUpload (file) {
      let v = this;
      v.file = file;
      return false;
    },
    // 确认上传excel
    confirmUploadExcel () {
      let v = this;
      if (v.file === null) {
        v.$Message.error(v.t('error.selectModalFile'));
        v.excelModal = true;
        return;
      }
      v.uploadLoading = true; // 开始上传加载中
      v.$refs['uploadFiles'].post(v.file);
    },
    // 取消上传excel
    cancelUploadExcel () {
      let v = this;
      v.file = null;
      v.excelModal = false;
    },
    // 显示导入模态框
    showImportExcelModal () {
      let v = this;
      v.excelModalStatus = true;
      v.$nextTick(function () {
        v.excelModal = true;
      });
    },
    // 数组里边对象去重
    filterDeleteArrFn (arr, name) {
      var hash = {};
      return arr.reduce(function (item, next) {
        if (!hash[next[name]]) {
          hash[next[name]] = true;
          item.push(next);
        }
        return item;
      }, []);
    },
    // 保存渠道
    saveBtn () {
      let v = this;
      let pos = [];
      v.loading2 = true; // 保存加载
      // 组装参数
      // 动态参数
      for (let i = 0; i < v.dyParams.length; i++) {
        let out = v.dyParams[i];
        if (v.dyParams[i].optionList != null) { // 有选项
          for (let t = 0; t < v.dyParams[i].optionList.length; t++) {
            let lining = v.dyParams[i].optionList[t];
            if (out.parameterType === '01') {
              if (out.paramValue1 === lining.parameterValue) {
                pos.push({
                  parameterValue: out.paramValue1,
                  parameterDesc: out.parameterName,
                  parameterKey: out.parameterKey
                });
              }
            } else if (out.parameterType === '02') {
              let parameterValue = '';
              for (let n = 0; n < out.paramValue2.length; n++) {
                if (out.paramValue2[n] === lining.parameterValue) {
                  if (parameterValue !== '') {
                    parameterValue += ',';
                  }
                  parameterValue += lining.parameterValue;
                }
              }
              if (parameterValue !== '') {
                pos.push({
                  parameterValue: parameterValue,
                  parameterDesc: out.parameterName,
                  parameterKey: out.parameterKey
                });
              }
            } else if (out.parameterType === '04') {
              if (out.paramValue4 === lining.parameterValue) {
                pos.push({
                  parameterValue: out.paramValue4,
                  parameterDesc: out.parameterName,
                  parameterKey: out.parameterKey
                });
              }
            }
          }
        } else if (out.parameterType === '03') { // 没有选项
          if (out.paramValue3 != null && out.paramValue3 !== '') {
            pos.push({
              parameterValue: out.paramValue3,
              parameterDesc: out.parameterName,
              parameterKey: out.parameterKey
            });
          }
        }
      }
      let extendObj = {
        deliveryEfficiencyMax: v.pageParams.deliveryEfficiencyMax, // 参考时效最大值
        deliveryEfficiencyMin: v.pageParams.deliveryEfficiencyMin, // 参考时效最小值
        isInsurance: v.pageParams.isInsurance, // 保险服务
        maxSizeHeight: v.pageParams.maxSizeHeight, // 尺寸限制高
        maxSizeLength: v.pageParams.maxSizeLength, // 尺寸限制长
        maxSizeWidth: v.pageParams.maxSizeWidth, // 尺寸限制宽
        weightRangeStart: v.pageParams.weightRangeStart, // 适用重量起始值
        weightRangeEnd: v.pageParams.weightRangeEnd, // 适用重量截止值
        logisType: v.pageParams.logisType, // 渠道类型
        shippingMethodExtendInfoId: v.pageParams.shippingMethodExtendInfoId
      };
      if (v.extendValue1.length !== 0) {
        v.extendValue1.forEach((n, i) => {
          v.pageParams.extendTypeList.push({
            extendType: 1,
            extendValue: n
          });
        });
      }
      if (v.pageParams.extendValue2.length !== 0) {
        v.pageParams.extendValue2.forEach((m, t) => {
          v.pageParams.extendTypeList.push({
            extendType: 2,
            extendValue: m
          });
        });
      }
      v.pageParams.priceModel.priceModelZoneList = v.chargData;
      let objParams = {
        shippingMethodId: v.shippingId, // 渠道ID
        extendInfo: extendObj,
        shippingMethodName: v.pageParams.shippingMethodName, // 渠道名称
        shippingMethodCode: v.pageParams.shippingMethodCode, // 渠道代码
        shippingCompanyId: v.pageParams.shippingCompanyId, // 物流公司ID
        extendTypeList: v.filterDeleteArrFn(v.pageParams.extendTypeList, 'extendValue'), // 渠道扩展类型（包裹类型、接受类型）
        hasTrackingNumber: v.pageParams.hasTrackingNumber, // 是否有跟踪号
        isPrintTemplate: v.pageParams.isPrintTemplate, // 是否支持接口传送面单
        confirmRequired: v.pageParams.confirmRequired, // 是否需要交运
        trackUrl: v.pageParams.trackUrl, // 追踪信息查询网址
        defParamList: pos, // 保存的动态参数
        deliverDesc: v.pageParams.deliverDesc, // 发货说明
        pickupCityList: v.pageParams.pickupCityList, // 揽收城市
        priceModel: v.pageParams.priceModel ? v.pageParams.priceModel : null // 计费模型
      };
      if (v.saveValidFn()) {
        v.axios.post(api.add_shipping2ver, objParams)
          .then(res => {
            if (res.data.code === 0) {
              v.loading2 = false; // 保存加载
              v.$Message.success(v.t('common.saveSuccess'));
              v.$parent.workShow = 'list'; // 新增成功之后，关闭模态框
              v.pageParams.extendTypeList = []; // 保存成功之后,清空包裹类型和接收类型
              v.clearFormData();
              v.$parent.pageParamsStatus = true; // 保存成功之后，触发表格刷新
              if (v.clickChargeFlag === '1') {
                v.$refs.clearTableData.cachePricingData = []; // 清除分段计费模型数据
                v.$refs.clearTableData.pricingParams.volumeWeight = 0; // 清除材积重
                v.$refs.clearTableData.pricingParams.priceType = 1; // 保存之后，计费方式重置1
                v.$refs.clearTableData.pricingParams.weightType = 1; // 保存之后，计重方式重置1
              }
              v.pageParams.pickupCityList = []; // 揽收城市清空
            } else {
              v.loading2 = false; // 保存加载
              v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
              // v.pageParams.pickupCityList = []; // 揽收城市清空
            }
          });
      } else {
        v.loading2 = false; // 保存加载
      }
    },
    // 取消新增
    cancel () {
      let v = this;
      if (v.addFlag === 'add') {
        v.$parent.workShow = 'list'; // 关闭模态框
        v.clearFormData();
        if (v.clickChargeFlag === '1') {
          v.$refs.clearTableData.cachePricingData = []; // 清除分段计费模型数据
          v.$refs.clearTableData.pricingParams.volumeWeight = 0; // 清除材积重
          v.$refs.clearTableData.pricingParams.priceType = 1; // 保存之后，计费方式重置1
          v.$refs.clearTableData.pricingParams.weightType = 1; // 保存之后，计重方式重置1
        }
      } else {
        v.$parent.workShow = 'list'; // 关闭模态框
        if (v.clickChargeFlag === '1') {
          v.$refs.clearTableData.cachePricingData = []; // 清除分段计费模型数据
          v.$refs.clearTableData.pricingParams.volumeWeight = 0; // 清除材积重
          v.$refs.clearTableData.pricingParams.priceType = 1; // 保存之后，计费方式重置1
          v.$refs.clearTableData.pricingParams.weightType = 1; // 保存之后，计重方式重置1
        }
      }
    },
    // 获取省份列表
    getProvinceList () {
      let v = this;
      v.axios.get(api.get_province)
        .then(res => {
          if (res.data.code === 0) {
            v.provinceList = res.data.datas;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 根据已选省份查询城市
    selectProvince (stateId) {
      let v = this;
      v.showFlag = !v.showFlag;
      v.axios.get(api.get_city + '?stateIds=' + stateId)
        .then(res => {
          if (res.data.code === 0) {
            v.refreshStatus = false;
            v.$nextTick(function () {
              v.refreshStatus = true;
            });
            v.cityList = res.data.datas;
          } else {
            v.showErrorInfoFn(res.data.code, res.data.message); // 错误提示方法
          }
        });
    },
    // 新增国家计费模型
    addCharge () {
      let v = this;
      v.pricingModal = true;
      v.isAddOrEdit = 'add';
      v.clickChargeFlag = '1';
    },
    // 整理国家数据
    setStateData (index, type) {
      let v = this;
      let stateNameArr = [];
      for (let i = 0; i < v.chargData.length; i++) {
        if (i === index) {
          let item = v.chargData[index].arriveCountryList;
          for (let t = 0; t < item.length; t++) {
            let subItem = item[t];
            stateNameArr.push(subItem.cnName);
            v.alreadySelectedCountry = stateNameArr;
            if (t === item.length - 1 && type === 'text') {
              return stateNameArr.toString();
            }
          }
        }
      }
    },
    // 清空表单数据
    clearFormData () {
      let v = this;
      v.chargData = []; // 计费模型表格
      v.extendValue1 = []; // 可接受包裹类型
      v.pageParams.extendValue2 = []; // 接收类型
      v.pageParams.deliveryEfficiencyMax = ''; // 参考时效最大值
      v.pageParams.deliveryEfficiencyMin = ''; // 参考时效最小值
      v.pageParams.isInsurance = ''; // 保险服务
      v.pageParams.maxSizeHeight = ''; // 尺寸限制高
      v.pageParams.maxSizeLength = ''; // 尺寸限制长
      v.pageParams.maxSizeWidth = ''; // 尺寸限制宽
      v.pageParams.weightRangeStart = ''; // 适用重量起始值
      v.pageParams.weightRangeEnd = ''; // 适用重量截止值
      v.pageParams.logisType = ''; // 渠道类型
      v.pageParams.shippingMethodName = ''; // 渠道名称
      v.pageParams.shippingMethodCode = ''; // 渠道代码
      v.pageParams.shippingCompanyId = ''; // 物流公司ID
      v.pageParams.hasTrackingNumber = ''; // 是否有跟踪号
      // v.pageParams.isPrintTemplate = ''; // 是否支持接口传送面单
      // v.pageParams.confirmRequired = ''; // 是否需要交运
      v.pageParams.trackUrl = ''; // 追踪信息查询网址
      v.pageParams.deliverDesc = ''; // 发货说明
      v.cloCityList = []; // 揽收城市
      v.provinceParams = []; // 省份
      v.cityParams = []; // 城市
    },
    // 下载错误日志
    downloadError () {
      let v = this;
      window.location.href = v.errorDownloadLink;
    },
    // 取消下载错误日志
    cancelDownLoad () {
      this.errorTipModal = false;
    }
  },
  created () {
    let v = this;
    v.getParams(); // 动态参数
    if (v.shippingId) {
      v.shipId = v.shippingId; // 渠道ID
      setTimeout(function () {
        v.getCanalDtlInfo(); // 编辑渠道信息
      }, 100);
    } else {
      v.shipId = null;
    }
    v.modelParams.shippingMethodId = v.shippingId;
  },
  watch: {
    addFlag: function (val) {
      if (val === 'add') {
        this.clearFormData();
      }
    },
    excelModalStatus (n) {
      let v = this;
      if (n === true) {
        v.file = null;
        v.modelParams.shippingMethodId = v.shippingId;
      }
    },
    pricingModal (n) {
      let v = this;
      if (n === false) {
        v.isAddOrEdit = '';
        v.$refs.clearTableData.pricingParams.checkCountry = [];
      } else {
        v.$refs.clearTableData.checkOzuTypeFn('Americas'); // 重新打开计费模态框，初始化为美国
      }
    },
    chargData (val) {
      let v = this;
      if (val) {
        for (let i = 0; i < val.length; i++) {
          let arr = val[i].arriveCountryList;
          for (let j = 0; j < arr.length; j++) {
            let arrItem = arr[j];
            v.getArriveCountryList.push(arrItem.countryId); // 已经选中的所有计费模型国家ID
          }
        }
      } else {
        v.getArriveCountryList = [];
      }
    },
    collectCityModal (n) {
      let v = this;
      if (n === true) {
        v.getProvinceList(); // 省份接口数据
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/logisticsProvider/components/logisticsProvider/channelManagementDetail.vue